import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'primereact/button';
import { Formik, Field, Form } from 'formik';
import * as yup from 'yup';
import { injectIntl } from 'react-intl';
import QuestionField from './QuestionField';
import Debug from '../../../../components/Debug';
import messages from '../intl-messages';
import { withGrowl } from '../../../../components/GrowlNotifications';


const validationSchema = formatMessage => yup.object().shape({
  question: yup.string()
    .max(250, formatMessage(messages.questionValidationMaxLength))
    .required(formatMessage(messages.questionValidationRequired)),
});

const CreateTextField = ({
  addGlobalAriField, currentAccount, intl: { formatMessage }, growl,
}) => (
  <Formik
    validationSchema={validationSchema(formatMessage)}
    initialValues={{ question: '' }}
    onSubmit={(values, { resetForm, setSubmitting }) => {
      setSubmitting(true);
      const newField = {
        dataType: 'TEXT',
        question: values.question,
        answers: [],
      };
      addGlobalAriField({
        variables: {
          input: {
            accountId: currentAccount,
            fields: [newField],
          },
        },
      })
        .then(() => {
          setSubmitting(false);
          growl.show({
            severity: 'success',
            sticky: false,
            summary: formatMessage(messages.growlAddFieldSuccessSummary),
            detail: formatMessage(messages.growlAddTextFieldSuccessDetail),
          });
          resetForm();
        })
        .catch(() => {
          setSubmitting(false);
          growl.show({
            severity: 'error',
            sticky: true,
            summary: formatMessage(messages.growlAddFieldFailSummary),
            detail: formatMessage(messages.growlAddTextFieldFailDetail),
          });
        });
    }}
  >
    {({ isValid, isSubmitting }) => (
      <Form>
        <div className="p-col-12" style={{ margin: '0' }}>
          <Field
            component={QuestionField}
            name="question"
            rows={5}
            cols={30}
            placeholder={formatMessage(messages.enterQuestionPlaceholder)}
          />

          <Button
            style={{ marginTop: '5px' }}
            type="submit"
            label={formatMessage(messages.submitLabel)}
            disabled={!isValid || isSubmitting}
          />
        </div>
        <Debug />
      </Form>
    )}

  </Formik>
);

CreateTextField.propTypes = {
  addGlobalAriField: PropTypes.func.isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(withGrowl(CreateTextField));
